import React, { useState , useRef , useEffect} from "react";
import useStyles from "./style";
import { useTheme } from '@mui/material/styles';
import {
  Box,
  IconButton, 
  TextField,
  Drawer,
  Typography
} from "@mui/material";
import {Close , LocationOn } from  "@mui/icons-material";
// Components 

import DistanceAndRate from "./DistanceDuration"
import Estimatedcarousel from "./Estimatedcarousel"
import CreateTrip from "./Createtripform"

const BookingForm = ({setOpen, setOpenbooking , openbooking , 
  setOrigin , setDestination , origin , destination, setMapCenter , services , timezone , userType , subcmpnyName}) => {
const classes = useStyles();
const theme = useTheme();
const [pickupLatLng, setPickupLatLng] = useState(null);
const [dropLatLng, setDropLatLng] = useState(null);
const [distance, setDistance] = useState(null);
const [duration, setDuration] = useState(null);
const [travelDuration,setTravelduration] = useState('');
const activecarouselRef = useRef(null);
const [pickupInput, setPickupInput] = useState('');
const [pickupSuggestions, setPickupSuggestions] = useState([]);
const [dropInput, setDropInput] = useState('');
const [dropSuggestions, setDropSuggestions] = useState([]);
const autocompleteService = useRef(null);
const placesServiceRef = useRef(null);


useEffect(() => {
if (!autocompleteService.current && window.google) {
  autocompleteService.current = new window.google.maps.places.AutocompleteService();
}
}, []);

useEffect(() => {
  if (!placesServiceRef.current && window.google && document.getElementById('map-temp')) {
    placesServiceRef.current = new window.google.maps.places.PlacesService(document.getElementById('map-temp'));
  }
}, []);

const handlePickupChange = (e) => {
  const value = e.target.value;
  setPickupInput(value);
  if (value.length >= 6 && autocompleteService.current) {
    autocompleteService.current.getPlacePredictions({
      input: value
    }, (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        setPickupSuggestions(predictions);
      } else {
        setPickupSuggestions([]);
      }
    });
  } else {
    setPickupSuggestions([]);
  }
};

const handleDropChange = (e) => {
  const value = e.target.value;
  setDropInput(value);
  if (value.length >= 6 && autocompleteService.current) {
    autocompleteService.current.getPlacePredictions({
      input: value
    }, (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        setDropSuggestions(predictions);
      } else {
        setDropSuggestions([]);
      }
    });
  } else {
    setDropSuggestions([]);
  }
};

const handlePickupSelect = (placeId, description) => {
  placesServiceRef.current.getDetails({ placeId }, (place, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setPickupLatLng({ lat, lng });
      setOrigin(description);
      setPickupInput(description);
      setPickupSuggestions([]);
    }
  });
};

const handleDropSelect = (placeId, description) => {
  placesServiceRef.current.getDetails({ placeId }, (place, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setDropLatLng({ lat, lng });
      setDestination(description);
      setDropInput(description);
      setDropSuggestions([]);
    }
  });
};

const toggleDrawer = (drawer, isOpen) => () => {
  if (drawer === 'left') setOpen(isOpen);
  if (drawer === 'right') setOpenbooking(isOpen);
};

  return (
<>

<img
src="/assets/images/logos/Add-trip.png" // Replace with the path to your image
alt="Open Drawer"
style={{ width: '100px', height: '80px' }}
aria-label="open booking drawer"
onClick={toggleDrawer('right', true)}
edge="start"
sx={{ ...(openbooking && { display: 'none' }) }}
className={classes.bookingiconbuttonopen} // Adjust size as needed
/>

  
<IconButton className={classes.formboxcloseicon} onClick={toggleDrawer('right', false)}
// sx={{ ...(!openbooking && { display: 'none' }) }}
sx={{
  opacity: openbooking ? 1 : 0,
  visibility: openbooking ? "visible" : "hidden",
  transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
}}
>
{theme.direction === 'ltr' ? <Close /> : <Close />}
</IconButton>


<Drawer className={classes.drawerformbox}
variant="persistent"
anchor="right" 
open={openbooking}
>

<Box className={classes.bookingformbox}>

<div className={classes.booking_header} >

<Typography variant="h5" component="h2">
New Booking
</Typography>

</div>
<div id="map-temp" style={{ display: 'none' }}></div>
<div className={classes.autocomplete_control}>

<Box sx={{ display: "flex", flexDirection: "column", gap: 1, position: "relative", width: "100%" }}>

{/* Pickup Location */}

<Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
<LocationOn sx={{ color: "green", position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }} />
  <TextField
    id="pickuplocation"
    label="Pickup Location"
    variant="outlined"
    size="small"
    value={pickupInput}
    onChange={handlePickupChange}
    className={classes.autocomplete_inputs}
  />

  <Box
  sx={{
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    zIndex: 5,
    background: "#fff",
    boxShadow: 3,
    maxHeight: 200, // Limit height
    overflowY: "auto", // Enable scrolling
  }}
>    {pickupSuggestions.map((suggestion) => (
      <Box
        key={suggestion.place_id}
        sx={{ padding: 1, cursor: "pointer", '&:hover': { backgroundColor: "#eee" } }}
        onClick={() => handlePickupSelect(suggestion.place_id, suggestion.description)}
      >
        {suggestion.description}
      </Box>
    ))}
  </Box>
</Box>

{/* Dotted Line */}
<Box sx={{ height: 20, width: 2, background: "gray", marginLeft: "18px", opacity: 0.5, borderLeft: "2px dotted gray" }} />

{/* Drop Location */}

<Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
<LocationOn sx={{ color: "red", position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }} />

<TextField
id="drop"
label="Drop Location"
variant="outlined"
size="small"
value={dropInput}
onChange={handleDropChange}
className={classes.autocomplete_inputs}
/>

  <Box
  sx={{
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    zIndex: 5,
    background: "#fff",
    boxShadow: 3,
    maxHeight: 200, // Limit height
    overflowY: "auto", // Enable scrolling
  }}
>   {dropSuggestions.map((suggestion) => (
    <Box
      key={suggestion.place_id}
      sx={{ padding: 1, cursor: "pointer", '&:hover': { backgroundColor: "#eee" } }}
      onClick={() => handleDropSelect(suggestion.place_id, suggestion.description)}
    >
      {suggestion.description}
    </Box>
  ))}
</Box>
</Box>


</Box>

</div>

{/* distance and duration */}

<DistanceAndRate 
pickupLatLng={pickupLatLng} dropLatLng={dropLatLng} 
origin={origin} destination={destination} distance={distance} duration={duration}
setMapCenter={setMapCenter} setDistance={setDistance} setDuration={setDuration}
 />

{/* Estimated carousel */}

<Estimatedcarousel distance={distance} duration={duration} services={services} 
setTravelduration={setTravelduration} timezone={timezone} activecarouselRef={activecarouselRef}/>

{/* form to create trip */}
<CreateTrip 
userType={userType} subcmpnyName={subcmpnyName}
origin={origin} destination={destination}
pickupLatLng={pickupLatLng} dropLatLng={dropLatLng}
distance={distance} duration={duration} travelDuration={travelDuration}
activecarouselRef={activecarouselRef}
/>
</Box>

</Drawer>

</>
  );
};

export default BookingForm;
